import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

export const ClusterCloudApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const { apps } = useAvailableApps()
    return (
      <FullPageAppTemplate
        appId={AppId.CLUSTER_CLOUD}
        scope='cluster_cloud'
        envKey={apps[AppId.CLUSTER_CLOUD].runtimeEnvKey}
        entryPath='./ClusterCloudApp'
        url={process.env.REACT_APP_CLUSTER_CLOUD_APP_DEV_PATH}
        appName={apps[AppId.CLUSTER_CLOUD].name}
        appProps={{
          user,
          history: history,
          appPath: apps[AppId.CLUSTER_CLOUD].path,
          initialPath: location.pathname,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location
            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          }
        }}
      />
    )
  },
  () => true
)
